import { getApiBaseUrl } from '../config/apiBaseUrl';

class ApiService {
  async makeRequest(endpoint, options = {}) {
    const url = `${getApiBaseUrl()}${endpoint}`;
    const defaultOptions = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers
      }
    };

    const response = await fetch(url, { ...defaultOptions, ...options });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  async makeAuthenticatedRequest(endpoint, accessToken, options = {}) {
    return this.makeRequest(endpoint, {
      ...options,
      headers: {
        ...options.headers,
        'Authorization': `Bearer ${accessToken}`
      }
    });
  }

  async getMe(accessToken) {
    return this.makeAuthenticatedRequest('/api/me', accessToken);
  }

  async getTransactions(accessToken) {
    return this.makeAuthenticatedRequest('/api/transactions', accessToken);
  }
}

const apiService = new ApiService();
export default apiService;
